import React from "react";
import "../styles/About.css";
import Aboutbanner from "../Page-section/About/Aboutbanner";
import AboutUs from "../Page-section/About/AboutUs";
import WhyChooseUs from "../Page-section/About/WhyChooseUs";
import Achievements from "../Page-section/About/Achievements";
import TestimonialSlider from "../Page-section/Home/TestimonialSlider";
import CertificationSection from "../Page-section/Home/certification";
import ShopNow from "../Page-section/Home/ShopNow";

function About() {
  return (
    <div>
      <Aboutbanner />
      <AboutUs />
      <WhyChooseUs />
      <Achievements />
      <ShopNow />
      <TestimonialSlider />
      <CertificationSection />
    </div>
  );
}

export default About;
